import React, { useContext } from 'react'
import Page from '../../general_components/Page'
import {Grid, Box, Container, IconButton, Stack, Typography, Avatar} from '@mui/material'
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { PRIMARY_COLOR_MediumRoyalBlue } from '../../constants/Colors';
import {Link, useParams} from 'react-router-dom';
import ProjectSlider from './components/ProjectSlider';
import { ProjectContext } from '../../contexts/ProjectContext';
import {getAPIEndpointUrl} from "../../utils/ServerRequestModifier";

const ProjectDetail = () => {

    const {
      selectedProjectId,
      setselectedProjectId,
      handleSelectedProject,
      selectedProject,
    } = useContext(ProjectContext);

    const {projectId} = useParams();

    React.useEffect(() => {
      handleSelectedProject(projectId);
    }, [projectId]);

  const status = [
    {title: 'Typology', value: selectedProject?.typology},
    {title: 'Area', value: selectedProject?.area},
    {title: 'Location', value: selectedProject?.location},
    {title: 'Status', value: selectedProject?.status},
    {title: 'Date', value: selectedProject?.date},
    {title: 'Sub Category', value: selectedProject?.subCategory},
  ];


  return (
    <Page>
      <Container>
        <Box display={"flex"} alignItems={"center"} mb={1}>
          <Link
              to="/projects"
              onClick={() => {
                setselectedProjectId(null);
              }}
          >
            <IconButton color="primary" aria-label="add to shopping cart">
              <ArrowBackIosNewRoundedIcon />
            </IconButton>
          </Link>
          <Typography
              color="text.secondary"
              sx={{ fontWeight: 550, fontSize: "16px" }}
          >
            Back
          </Typography>
        </Box>
        <Grid container>
          <Grid item xs={12} sm={12} md={4} pr={2}>
            <img
                style={{ width: "100%", objectFit: 'cover', borderRadius: "0px" }}
                src={getAPIEndpointUrl() + selectedProject?.cardImage}
                alt={selectedProject?.title}
            />
            <Typography
                color={PRIMARY_COLOR_MediumRoyalBlue}
                sx={{ fontWeight: 700, fontSize: "24px" }}
                pb={1} pt={1}
            >
              {selectedProject?.title}
            </Typography>
            <Grid container>
              {
                status.map((item, index) => {
                  return (
                      <Grid key={`WorkDetails${index}`} item xs={6} sm={6} md={6} pb={2}>
                        <Typography variant={'body1'} color="text.secondary" sx={{ fontWeight: 550, fontSize: "16px" }}>
                          {item.title}
                        </Typography>
                        <Typography variant={'body1'} sx={{fontWeight: 400}}>
                          {item.value}
                        </Typography>
                      </Grid>
                  )
                })
              }
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <ProjectSlider selectedProject={selectedProject}  />
            <Typography variant={'h6'} pt={2}>{selectedProject?.description}</Typography>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}

export default ProjectDetail